<template>
  <form @submit.prevent class="p-t-15 date-form" role="form" novalidate="novalidate">
    <div class="form-group">
      <div class="radio radio-success">
        <input type="radio" id="full_day" name="dayTime" :value="'full_day'"
                aria-invalid="false" v-model="dayTime" @click="changeDayTime('full_day')">
        <label for="full_day">{{ trans('UnavailabilityCalendar.full_day') }}</label>
        <div class="m-t-5"></div>
        <input type="radio" id="specific_times" name="dayTime" :value="'specific_times'"
                aria-invalid="false" v-model="dayTime"  @click="changeDayTime('specific_times')">
        <label for="specific_times">{{ trans('UnavailabilityCalendar.specific_times') }}</label>
      </div>
    </div>

    <div class="form-group">
      <div class="pull-right checkbox">
        <input id="several_days" name="several_days" type="checkbox" v-model="isSeveralDays" />
        <label for="several_days" v-html="trans('UnavailabilityCalendar.several_days')">
        </label>
      </div>
    </div>
    <div class="clearfix"></div>

    <div class="form-group">
      <tr>
        <td class="label-date">
          <div class="font-montserrat">
            {{ isSeveralDays ? trans("UnavailabilityCalendar.start_date") : trans("UnavailabilityCalendar.only_date") }}
          </div>
        </td>
        <td class="input-date">
          <date-picker v-model="startDate" class="p-t-10 date-picker--small" name="startDate"
                        v-validate="{ required: true }" :data-vv-as="' '" />
          <transition name="slide-fade">
            <label v-show="errors.has('startDate')" class="error" for="startDate">
              {{ errors.first('startDate') }}</label>
          </transition>
        </td>
        <td class="label-time" v-show="isSpecificTimes">
          <div class="font-montserrat">
            {{ isSeveralDays ? trans("UnavailabilityCalendar.end_time") : trans("UnavailabilityCalendar.start_time") }}
          </div>
        <td>
        <td class="input-time" v-show="isSpecificTimes">
          <time-picker v-model="startTime" :value="startTime" class="p-t-10 time-picker--small"
                        name="startTime" v-validate="{ required: true }" :data-vv-as="' '" :isCheckEmpty="true"/>
          <transition name="slide-fade">
            <label v-show="errors.has('startTime')" class="error" for="startTime">
              {{ errors.first('startTime') }}</label>
          </transition>
        </td>
      </tr>
      <tr>
        <td class="label-date" v-if="isSeveralDays">
          <div class="font-montserrat">{{ trans("UnavailabilityCalendar.end_date") }}</div>
        </td>
        <td v-else></td>
        <td class="input-date" v-if="isSeveralDays">
          <date-picker v-model="endDate" class="p-t-10 date-picker--small" name="endDate"
                        v-validate="{ required: true }" :data-vv-as="' '" />
          <transition name="slide-fade">
            <label v-show="errors.has('endDate')" class="error" for="endDate">
              {{ errors.first('endDate') }}</label>
          </transition>
        </td>
        <td v-else></td>
        <td class="label-time" v-show="isSpecificTimes">
          <div class="font-montserrat">{{ trans("UnavailabilityCalendar.end_time") }}</div>
        <td>
        <td class="input-time" v-show="isSpecificTimes">
          <time-picker v-model="endTime" :value="endTime" class="p-t-10 time-picker--small"
                        name="endTime" v-validate="{ required: true }" :data-vv-as="' '" :isCheckEmpty="true" />
          <transition name="slide-fade">
            <label v-show="errors.has('endTime')" class="error" for="endTime">
              {{ errors.first('endTime') }}</label>
          </transition>
        </td>
      </tr>
    </div>
    <div class="form-group" v-show="!this.isValidDateForm">
      <label class="error">
        {{ endAt.diff(startAt, 'days') === 0 ? trans("UnavailabilityCalendar.time_invalid") : trans("UnavailabilityCalendar.date_invalid") }}
      </label>
    </div>

    <div class="form-group" v-if="error_messages">
      <div class="alert alert-danger position-relative" role="alert">
        <button class="close position-absolute" @click="error_messages = null"></button>
        <ul v-if="error_messages.constructor === Array" class="px-2">
          <li v-for="(error_message, index) in error_messages" :key="`error_message_${index}`">
            {{ error_message }}
          </li>
        </ul>
        <ul v-else><li>{{ error_messages }}</li></ul>
      </div>
    </div>

    <div class="form-group m-t-40">
      <p class="line m-t-40"></p>
      <button @click="closeForm" class="btn btn-default btn-cons pull-left" :disabled="submitState === 'pending'">
        {{ trans("buttons.cancel") }}</button>
      <button @click="saveForm()" class="btn btn-primary btn-cons pull-right" type="button" :disabled="submitState === 'pending'">
        <i class="fa fa-refresh fa-spin" v-if="submitState === 'pending'"></i>
        {{ trans("actions.save") }}
      </button>
    </div>
    <div class="clearfix"></div>
  </form>
</template>

<script>
import i18n from '@/lang'
import ie_mixin from '@/mixin/ie'
import DatePicker from '@/components/pages/DatePicker'
import TimePicker from '@/components/pages/TimePicker'
import { mapActions } from 'vuex'
import moment from 'moment-timezone'
import { sendCandidateSetUnavailabiltyDateEvent } from '@/helpers/at_internet/follow_candidate'

export default {
  name: "UnavailabilityDateForm",
  mixins: [ie_mixin],
  components: { DatePicker, TimePicker },
  props: ['selectedDate'],
  data: function() {
    return {
      startDate: '',
      endDate: '',
      startTime: '',
      endTime: '',
      dayTime: 'full_day',
      isSeveralDays: false,
      form: {
        start_at: '',
        end_at: ''
      },
      error_messages: null,
      submitState: "success",
    }
  },
  computed: {
    unavailabilityDate() {
      return this.$store.state.unavailabilityDates.unavailabilityDate;
    },
    isSpecificTimes() {
      return this.dayTime == 'specific_times';
    },
    isFullDay() {
      return this.dayTime == 'full_day';
    },
    actionName () {
      return this.unavailabilityDate && this.unavailabilityDate.id ? 'unavailabilityDates/update' : 'unavailabilityDates/create'
    },
    startAt() {
      if(this.isFullDay){
        return moment(this.startDate, i18n.t('format.show_date_form')).startOf("day")
      } else {
        return moment(`${this.startDate} ${this.startTime}`, i18n.t('format.date_time'))
      }
    },
    endAt() {
      let endDate = this.isSeveralDays ? this.endDate : this.startDate
      if(this.isFullDay){
        return moment(endDate, i18n.t('format.show_date_form')).endOf("day")
      } else {
        let endTime = this.endTime === "23:59" ? "23:59:59" : this.endTime
        return moment(`${endDate} ${endTime}`, i18n.t('format.date_time'))
      }
    },
    isValidDateForm(){
      return this.endAt > this.startAt
    }
  },
  watch: {
    selectedDate() {
      if(!(this.unavailabilityDate && this.unavailabilityDate.id)) {
        this.startDate = this.$options.filters.showDateForm(this.selectedDate);
        this.endDate = this.$options.filters.showDateForm(this.selectedDate);
        this.isSeveralDays = false;
        this.dayTime = 'full_day';
        this.startTime = this.$options.filters.showTimeForm(moment().startOf("day").add(8, 'hours'));
        this.endTime = this.$options.filters.showTimeForm(moment().startOf("day").add(18, 'hours'));
      }
    },
    unavailabilityDate(newDate) {
      if(newDate && newDate.id){
        this.form = newDate;
        this.startDate = this.$options.filters.showDateForm(newDate.start_at);
        this.endDate = this.$options.filters.showDateForm(newDate.end_at);
        this.startTime = this.$options.filters.showTimeForm(newDate.start_at);
        this.endTime = this.$options.filters.showTimeForm(newDate.end_at)
        this.dayTime = this.startTime == "00:00" && this.endTime == "23:59" ? 'full_day' : 'specific_times'
        this.isSeveralDays = moment(this.startDate, i18n.t('format.show_date_form')).diff(moment(this.endDate, i18n.t('format.show_date_form'))) != 0
      }
    }
  },
  methods: {
    ...mapActions({
      create: 'unavailabilityDates/create',
      loadUnavailabilityDateScheduled: 'unavailabilityDates/loadUnavailabilityDateScheduled'
    }),
    trans(text) {
      return i18n.t(text);
    },
    closeForm() {
      $('#modal-date-form').modal('hide');
      this.error_messages = null;
    },
    changeDayTime(type) {
      this.dayTime = type;
    },
    saveForm() {
      let self = this
      this.$validator.validateAll().then((result) => {
        if(result && this.isValidDateForm) {
          self.submitState = "pending"
          self.form = Object.assign({}, self.form, { start_at: self.startAt, end_at: self.endAt })
          self.$store.dispatch(self.actionName, self.form).then(() => {
            self.loadUnavailabilityDateScheduled({
              start_date: self.startAt.startOf('month').format(self.$i18n.t('format.date')),
              end_date: self.endAt.endOf('month').format(self.$i18n.t('format.date')),
            })
            self.closeForm();
          }).catch(e => {
            self.error_messages = e
          }).finally(() => {
            self.submitState = "success"
          })
        }
        sendCandidateSetUnavailabiltyDateEvent()
      });
    }
  },
  mounted: function(){
    var self = this
    $('#modal-date-form').on('hidden.bs.modal', function (e) {
      self.startDate = ''
      self.endDate = ''
      self.startTime = ''
      self.endTime = ''
      self.dayTime = 'full_day'
      self.isSeveralDays = false
      self.form = { start_at: '', end_at: '' }
      self.error_messages = null
      self.submitState = "success"
    })
    $('#modal-date-form').on('show.bs.modal', function (e) {
      if(e.namespace !== 'bs.modal') return;
      if(!(self.unavailabilityDate && self.unavailabilityDate.id)) {
        self.startDate = self.$options.filters.showDateForm(self.selectedDate);
        self.endDate = self.$options.filters.showDateForm(self.selectedDate);
        self.isSeveralDays = false;
        self.dayTime = 'full_day';
        self.startTime = self.$options.filters.showTimeForm(moment().startOf("day").add(8, 'hours'));
        self.endTime = self.$options.filters.showTimeForm(moment().startOf("day").add(18, 'hours'));
      }
    })
  }
}
</script>

<style lang="scss" scoped>
  .date-form {
    font-size: 1.1em !important;

    .form-group label {
      text-transform: capitalize;
      margin-bottom: 0;
      font-family: "Segoe UI", Arial, sans-serif;
      font-size: 12px;
    }
    .radio, .checkbox {
      margin-top: 0;
      margin-bottom: 0;
    }
    .font-montserrat {
      font-size: 12px;
      text-transform: uppercase;
    }
    .line {
      border-top: 1px solid #ddd;
      margin-bottom: 15px;
    }
    .label-date {
      width: 10%;
    }
    .input-date {
      width: 45%;
    }
    .label-time {
      width: 17%;
      .font-montserrat {
        text-align: right;
        padding-right: 15px;
      }
    }
    .input-time {
      width: 28%;
    }
  }
</style>



// WEBPACK FOOTER //
// src/components/unavailabilityCalendars/UnavailabilityDateForm.vue